import { Link } from 'react-router-dom';
import { popularVideos } from '@/mocks/videos';

const imageUrls: Record<string, string> = {
  'cyber-dream': 'https://readdy.ai/api/search-image?query=Cyberpunk%20ancient%20Chinese%20city%20with%20neon%20lights%20and%20traditional%20architecture%2C%20futuristic%20Song%20dynasty%20aesthetic%2C%20vibrant%20magenta%20and%20cyan%20lighting%2C%20cinematic%20composition&width=600&height=450&seq=popular-cyber-dream&orientation=landscape',
  'grandma-recipe': 'https://readdy.ai/api/search-image?query=Elderly%20Chinese%20grandmother%20cooking%20traditional%20food%20in%20rustic%20kitchen%2C%20warm%20steam%20rising%20from%20pot%2C%20cozy%20nostalgic%20atmosphere%2C%20soft%20natural%20lighting%2C%20documentary%20style&width=600&height=450&seq=popular-grandma-recipe&orientation=landscape',
  'dawn-patrol': 'https://readdy.ai/api/search-image?query=Chinese%20peacekeeping%20soldiers%20on%20patrol%20in%20African%20savanna%20at%20sunrise%2C%20warm%20golden%20light%2C%20vast%20landscape%2C%20strong%20silhouettes%2C%20professional%20military%20documentary%20photography&width=600&height=450&seq=popular-dawn-patrol&orientation=landscape',
  'love-letter': 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20couple%20reading%20handwritten%20letters%20by%20window%2C%20nostalgic%202000s%20setting%2C%20warm%20afternoon%20light%2C%20tender%20emotional%20moment%2C%20cinematic%20soft%20focus&width=600&height=450&seq=popular-love-letter&orientation=landscape',
  'robot-xiao': 'https://readdy.ai/api/search-image?query=Shenzhen%20electronics%20market%20with%20young%20Chinese%20engineer%20working%20on%20robot%20prototype%2C%20bustling%20tech%20atmosphere%2C%20warm%20indoor%20lighting%2C%20documentary%20entrepreneurship%20story&width=600&height=450&seq=popular-robot-xiao&orientation=landscape',
  'opera-reborn': 'https://readdy.ai/api/search-image?query=Chinese%20Peking%20opera%20performer%20with%20digital%20projection%20mapping%20on%20traditional%20costume%2C%20fusion%20of%20ancient%20art%20and%20modern%20technology%2C%20dramatic%20stage%20lighting%2C%20vibrant%20colors&width=600&height=450&seq=popular-opera-reborn&orientation=landscape',
  'grassland-song': 'https://readdy.ai/api/search-image?query=Mongolian%20grassland%20with%20nomadic%20family%20and%20horses%20at%20sunset%2C%20vast%20Inner%20Mongolia%20landscape%2C%20warm%20golden%20hour%20light%2C%20traditional%20yurt%20in%20distance%2C%20documentary%20photography&width=600&height=450&seq=popular-grassland-song&orientation=landscape',
  'code-breaker': 'https://readdy.ai/api/search-image?query=1940s%20Chinese%20codebreaker%20in%20dimly%20lit%20room%20with%20vintage%20radio%20equipment%2C%20wartime%20spy%20thriller%20atmosphere%2C%20warm%20sepia%20tones%2C%20suspenseful%20cinematic%20lighting&width=600&height=450&seq=popular-code-breaker&orientation=landscape',
};

export default function PopularSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-8 md:mb-12">
            <div>
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
                热门排行
              </span>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                观众最爱的视频
              </h2>
              <p className="text-sm text-foreground-500 mt-2 max-w-lg">
                根据播放量和用户评分综合排名的热门国产视频内容
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {popularVideos.map((video, index) => (
              <Link
                key={video.id}
                to={`/article/${video.id}`}
                className="group bg-background-100/60 rounded-xl overflow-hidden transition-all duration-300 hover:bg-background-100 cursor-pointer no-underline"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={imageUrls[video.id]}
                    alt={video.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <div className="absolute top-0 left-0 w-9 h-9 md:w-10 md:h-10 bg-primary-500 flex items-center justify-center rounded-br-xl">
                    <span className="font-heading font-bold text-sm text-background-50">{index + 1}</span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="flex items-center gap-1 px-2 py-0.5 bg-black/50 backdrop-blur-sm rounded text-xs text-accent-400">
                      <i className="ri-star-fill text-amber-400 text-[10px]"></i>
                      {video.rating}
                    </span>
                  </div>
                  <div className="absolute bottom-3 left-3 text-xs text-background-50/90 flex items-center gap-1.5">
                    <i className="ri-eye-line"></i>
                    {video.views} 次播放
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5 line-clamp-1">
                    {video.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                    {video.description}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{video.director}</span>
                    <span className="px-1.5 py-0.5 bg-secondary-100 text-secondary-600 rounded">
                      {video.categoryName}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}